export default Object.freeze({
  FIRST: 'call_first',
  AGAIN: 'call_again'
});
